module.exports = __webpack_public_path__ + "static/media/YF60_2.6df98841.jpg";